<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolSchoolWebsiteSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "News",
                description: "Create and manage news and announcements for your audience.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Blog",
                description: "Publish and manage articles on the school website.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Gallery",
                description: "Manage photos and media displayed on the school website.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Events",
                description: "Create and manage school events and activities.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Notices",
                description: "Publish important notices for students, parents, and staff.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Downloads",
                description: "Share useful files and resources on the school website.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Site Images",
                description: "Update images and visual content displayed across the website.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
